module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/collabs-logos/nightcap-26cdad3baa965d58ee9ad63dc3ee27ab.svg";